import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import MySql from '../../homepage/header-banner/MySql';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import Sidebar from '../../container/Sidebar/Sidebar'
import '../../container/Sidebar/sidebar.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Contentcloudcard from "../../container/Card/Components/Contentcloudcard"
import Imagecloudcompute from "../../container/Card/Components/Imagecloudcompute"
// import { MuiGrid } from '@mui/material';
import CardBox from '../../container/Box/Components/CardBox';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import DividerComponent from '../../container/Divider/divider';
import styled from 'styled-components';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import Cloudconsult2VN from '../../homepage/consult/cloudconsult-2-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

function ClustercloudmysqldbVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Private MySQL Cluster - Private Kubernetes - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className='main-body'>
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Kubernetes for MySQL(Maria)")} */}
                        {/* {Contentcloudcard("모든 컨테이너(POD) 고용량 SSD 디스크 제공, 고용량의 메모리 할당")} */}
                        <MuiGrid container spacing={3}>
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Cấu hình Master/Slave với khả năng tự động mở rộng (Autoscaling) cho máy chủ đọc</p>",
                                `<p class='typo-14'>Các container (POD) thuộc máy chủ MySQL Slave có thể tự động mở rộng để giảm tải và phân phối I/O hiệu quả.</p>
                                <p class='typo-14'>Hệ thống hỗ trợ cấu hình tương tự cho các hệ quản trị cơ sở dữ liệu như MySQL và MariaDB.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Vận hành volume Persistent với hiệu suất cao, tối ưu hóa I/O</p>",
                                `<p class='typo-14'>Dữ liệu được lưu trữ trên SSD và vận hành thông qua 3 container replica (POD) cho từng dịch vụ.</p>
                                <p class='typo-14'>Khi phần cứng tại node gặp sự cố, container replica (POD) sẽ tự động tiếp quản để đảm bảo dịch vụ hoạt động liên tục, không gián đoạn.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Tự động di chuyển container (POD) khi xảy ra sự cố phần cứng, đảm bảo hệ thống vận hành liên tục</p>",
                                `<p class='typo-14'>Container (POD) của dịch vụ MySQL trên Kubernetes gồm 3 bản sao (replica) cho mỗi dịch vụ.</p>
                                <p class='typo-14'>Các bản sao này được phân bố trên nhiều worker node khác nhau, đảm bảo khả năng phục hồi khi có sự cố phần cứng.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12} sm={12}>{CardBox(
                                "<p class='typo-21-sm typo-medium typo-black'>Tự động mở rộng quy mô container và cân bằng phân phối tài nguyên dịch vụ</p>",
                                `<p class='typo-14'>Số lượng container (POD) được điều chỉnh linh hoạt dựa trên nhu cầu sử dụng CPU, bộ nhớ hoặc mục tiêu cấu hình tùy biến.</p>
                                <p class='typo-14'>Hệ thống có thể mở rộng bằng cách bổ sung tài nguyên phần cứng và cấu hình lại dịch vụ khi cần thiết.</p>
                                <p class='typo-14'>Giải pháp cluster giúp tối ưu chi phí vận hành và đảm bảo phân phối tải hiệu quả.</p>`
                            )}
                            </MuiGrid>
                            <DividerComponent />
                            <MuiGrid item xs={12}>{Imagecloudcompute("https://www.hanbiro.com/cloud/library/cluster-cloud-mysql-db/mysql_cluster.svg")}</MuiGrid>
                            <DividerComponent />
                        </MuiGrid>

                        {/* <MySql title={"MySQL"} content={"MySQL"} content1={"MySQL"}/> */}

                        <Cloudconsult2VN />
                    </Col>
                </Row>
            </Container>


            <FooterVn />
        </Sysfont>

    );

};

const MuiGrid = styled.div`
    padding: 0px,
`

export default ClustercloudmysqldbVN;